// extracted by mini-css-extract-plugin
module.exports = {"defaultIconButton":"style-module_defaultIconButton__1FRbwmdiQWSCtPOnCFG4Na","copyValue":"style-module_copyValue__2jZdN_BLWd2xVwp5BdvAYA"};